import { testimonials } from "@/mocks/homeData";

export default function Testimonials() {
  return (
    <section id="testimonios" className="py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16 reveal">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-bold tracking-wide uppercase mb-4">
            Testimonios reales
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4">
            Lo que dicen quienes ya confiaron en nosotros
          </h2>
          <p className="text-foreground-600 text-base md:text-lg leading-relaxed">
            Más de 350 clientes satisfechos. Aquí algunos que nos dieron permiso de
            compartir su experiencia.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="reveal bg-background-100 rounded-2xl p-6 md:p-8 border border-background-200/70 flex flex-col"
              style={{ transitionDelay: `${i * 120}ms` }}
            >
              {/* Stars */}
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, si) => (
                  <i
                    key={si}
                    className="ri-star-fill text-accent-500 text-sm"
                  />
                ))}
                <span className="text-xs text-foreground-500 ml-1.5 font-medium">
                  5.0
                </span>
              </div>

              {/* Quote */}
              <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-6 flex-grow">
                "{t.text}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-3 pt-4 border-t border-background-200/60">
                <img
                  src={t.image}
                  alt={t.name}
                  className="w-10 h-10 rounded-full object-cover bg-background-200"
                />
                <div>
                  <div className="font-heading font-bold text-foreground-950 text-sm">
                    {t.name}
                  </div>
                  <div className="text-foreground-500 text-xs">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}